'use strict';

const libPictView = require('pict-view');

class PictViewTopBarNav extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		if (this.pict.CSSMap) { this.pict.CSSMap.injectCSS(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewTopBarNav;

module.exports.default_configuration =
{
	ViewIdentifier: 'Plansheet-TopBar-Nav',
	DefaultRenderable: 'Plansheet-TopBar-Nav',
	DefaultDestinationAddress: '#Theme-TopBar-Nav',
	AutoRender:                false,
	CSS: /*css*/`
		.cst-nav {
			display: flex; align-items: center; justify-content: flex-end; height: 100%;
			padding: 0 12px; gap: 8px; flex: 1 1 auto;
			color: var(--theme-color-text-on-brand,
				   var(--theme-color-text-primary, #1d2230));
			font-weight: 500;
		}
		/* No nav items yet: collapse the empty container so its padding does not
		   leave a sliver next to the user area. Shows again once it has content. */
		.cst-nav:empty { display: none; padding: 0; }
		.cst-nav-sep { opacity: 0.5; font-weight: 400; margin: 0 2px; }
		/* The "?" help toggle. Opens the contextual help drawer (also F1). */
		.cst-nav-help {
			display: flex; align-items: center; justify-content: center;
			width: 32px; height: 32px; padding: 0; border: none; border-radius: 8px;
			background: transparent; cursor: pointer; opacity: 0.85;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #1d2230));
		}
		.cst-nav-help:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.10)); opacity: 1; }
		.cst-nav-help svg { display: block; }
			/* Two left-pinned controls next to the logo, kept as one group by margin-right:auto on the
			   LAST of them (the rail-view toggle). First: sidebar show/hide (Plansheet-SidebarToggle,
			   same action as Cmd+B). Second: rail-view cycle (Plansheet-RailToggle, nav/notebook/split).
			   Each does exactly one thing; the app keeps their icons/state in sync (_updateSidebarToggle,
			   _updateRailToggle). The rail-view toggle is disabled while the sidebar is hidden. */
			.cst-nav-sidebar, .cst-nav-rail {
				display: flex; align-items: center; justify-content: center;
				width: 32px; height: 32px; padding: 0; border: none; border-radius: 8px;
				background: transparent; cursor: pointer; opacity: 0.85;
				color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #1d2230));
			}
			.cst-nav-rail { margin-right: auto; }
			.cst-nav-sidebar:hover, .cst-nav-rail:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.10)); opacity: 1; }
			.cst-nav-sidebar svg, .cst-nav-rail svg { display: block; }
			.cst-nav-rail:disabled { opacity: 0.3; cursor: default; }
			.cst-nav-rail:disabled:hover { background: transparent; opacity: 0.3; }
			/* The 9-square app launcher, left of the help button. Opens the cmd+K command palette. */
			.cst-nav-launcher {
				display: flex; align-items: center; justify-content: center;
				width: 32px; height: 32px; padding: 0; border: none; border-radius: 8px;
				background: transparent; cursor: pointer; opacity: 0.85;
				color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #1d2230));
			}
			.cst-nav-launcher:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.10)); opacity: 1; }
			.cst-nav-launcher svg { display: block; }
	`,
	Templates: [{
		Hash: 'Plansheet-TopBar-Nav',
		Template: /*html*/`<div class="cst-nav"><button class="cst-nav-launcher" title="Jump to... (Cmd+K)" aria-label="Open the launcher" onclick="_Pict.PictApplication.openCommandLauncher()"><svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><circle cx="5" cy="5" r="1.8"></circle><circle cx="12" cy="5" r="1.8"></circle><circle cx="19" cy="5" r="1.8"></circle><circle cx="5" cy="12" r="1.8"></circle><circle cx="12" cy="12" r="1.8"></circle><circle cx="19" cy="12" r="1.8"></circle><circle cx="5" cy="19" r="1.8"></circle><circle cx="12" cy="19" r="1.8"></circle><circle cx="19" cy="19" r="1.8"></circle></svg></button><button class="cst-nav-sidebar" id="Plansheet-SidebarToggle" title="Hide sidebar (Cmd+B)" aria-label="Show or hide the sidebar" onclick="_Pict.PictApplication.toggleSidebar()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"></rect><line x1="9" y1="4" x2="9" y2="20"></line><path d="M15.5 9l-2.5 3 2.5 3"></path></svg></button><button class="cst-nav-help" title="Help (F1)" aria-label="Help" onclick="_Pict.PictApplication.toggleHelpDrawer()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></button></div>`
	}],
	Renderables: [{
		RenderableHash: 'Plansheet-TopBar-Nav',
		TemplateHash: 'Plansheet-TopBar-Nav',
		ContentDestinationAddress: '#Theme-TopBar-Nav'
	}]
};
